{
"actions.addLocalFile": "Add local file",
"actions.deleteAndPush": "Delete existing file",
"actions.editAndPush": "Edit existing file",
"actions.fetchRemote": "Pull remote",
"actions.listAdapters": "List adapters",
"actions.listFilesRaw": "Run listFilesRaw()",
"actions.localChanges": "Local changes",
"actions.pushLocal": "Push local changeset",
"actions.remoteChanges": "Remote new files (changeset)",
"actions.rename": "Rename existing file",
"actions.resolveConflict": "Mark conflict resolved",
"actions.revertChange": "Revert change",
"actions.showSnapshot": "Show snapshot (local)",
"actions.showFileContent": "Show file content",
"actions.showConflictContent": "Show conflict content",
"actions.title": "Actions",
"branch.flag.default": "default",
"branch.flag.protected": "protected",
"confirm.delete": "Are you sure you want to delete: {path}?",
"createBranch.label": "Create branch",
"error.addLocalFile.failed": "[addLocalFileBtn] Failed to add local file: {err}",
"error.connect.exception": "[connectBtn]Exception during connect: {err}",
"error.connectIndexedDb.exception": "[connectIndexedDbBtn]Exception occurred while connecting to IndexedDatabaseStorage: {err}",
"error.connectInMemory.exception": "[connectInMemoryBtn]Exception occurred while connecting to InMemoryStorage: {err}",
"error.connectOpfs.exception": "[connectOpfsBtn]Exception occurred while connecting to OpfsStorage: {err}",
"error.createBranch.failed": "[createBranch]failed: {err}",
"error.createBranch.notImplemented": "[createBranch]VirtualFS does not implement createBranch()",
"error.createBranch.vfsNotInit": "[createBranch]Please initialize VirtualFS first",
"error.default": "{err}",
"error.deleteAndPush.failed": "[deleteAndPushBtn]deleteAndPush failed: {err}",
"error.deleteAndPush.noAdapter": "[deleteAndPushBtn]Please connect adapter first",
"error.deleteAndPush.vfsNotInit": "[deleteAndPushBtn]Please initialize VirtualFS first",
"error.deleteIndexedDb.failed": "[deleteIndexedDbBtn]Failed to delete: {err}",
"error.deleteIndexedDb.noCtor": "[deleteIndexedDbBtn]IndexedDatabaseStorage was not found",
"error.deleteIndexedDb.noMethod": "[deleteIndexedDbBtn]Delete method is not implemented for IndexedDatabaseStorage",
"error.deleteIndexedDb.noSelection": "[deleteIndexedDbBtn]No target database selected for deletion",
"error.deleteInMemory.failed": "[deleteInMemoryBtn]Failed to delete: {err}",
"error.deleteInMemory.noCtor": "[deleteInMemoryBtn]InMemoryStorage was not found",
"error.deleteInMemory.noMethod": "[deleteInMemoryBtn]Delete method is not implemented for InMemoryStorage",
"error.deleteInMemory.noSelection": "[deleteInMemoryBtn]No target root selected for deletion",
"error.deleteOpfs.failed": "[deleteOpfsBtn]Failed to delete: {err}",
"error.deleteOpfs.noCtor": "[deleteOpfsBtn]OpfsStorage was not found",
"error.deleteOpfs.noMethod": "[deleteOpfsBtn]Delete method is not implemented for OpfsStorage",
"error.deleteOpfs.noSelection": "[deleteOpfsBtn]No target root selected for deletion",
"error.editAndPush.failed": "[editAndPushBtn]editAndPush failed: {err}",
"error.editAndPush.noAdapter": "[editAndPushBtn]Please connect adapter first",
"error.editAndPush.vfsNotInit": "[editAndPushBtn]Please initialize VirtualFS first",
"error.fetchRemote.failed": "[fetchRemoteBtn]Pull failed: {err}",
"error.fetchRemote.indexException": "[fetchRemoteBtn]Exception showing index after pull: {err}",
"error.fetchRemote.vfsNotInit": "[fetchRemoteBtn]Please initialize VirtualFS first",

"error.indexeddb.connectFailed": "[indexedDbRoots] Connection failed: {err}",
"error.indexeddb.failed": "[indexedDbRoots] Retrieval failed: {err}",
"error.indexeddb.missing": "[indexedDbRoots] IndexedDatabaseStorage is not included in the bundle",
"error.indexeddb.notImplemented": "[indexedDbRoots] availableRoots() is not implemented in IndexedDatabaseStorage",
"error.inmemory.connectFailed": "[inMemoryRoots] Connection failed: {err}",
"error.inmemory.failed": "[inMemoryRoots] Retrieval failed: {err}",
"error.invalidUrl": "[connectBtn]Invalid URL. Example: https://github.com/owner/repo",
"error.listBranches.failed": "[listBranches]failed: {err}",
"error.listBranches.notImplemented": "[listBranches]VirtualFS does not implement listBranches()",
"error.listBranches.vfsNotInit": "[listBranches]Please initialize VirtualFS first",
"error.listCommits.failed": "[listCommits]failed: {err}",
"error.listCommits.notImplemented": "[listCommits]VirtualFS does not implement listCommits()",
"error.listCommits.vfsNotInit": "[listCommits]Please initialize VirtualFS first",
"error.listFilesRaw.failed": "[listFilesRaw]Exception running listFilesRaw: {err}",
"error.listFilesRaw.notImplemented": "[listFilesRaw]listFilesRaw() is not implemented on VirtualFS/Backend",
"error.listFilesRaw.vfsNotInit": "[listFilesRaw]Please initialize VirtualFS first",
"error.localChanges.failed": "[localChangesBtn]Local changes failed: {err}",
"error.localChanges.vfsNotInit": "[localChangesBtn]Please initialize VirtualFS first.",
"error.nextCommitsPage.failed": "[nextCommitsPage]failed: {err}",
"error.nextCommitsPage.noNext": "[nextCommitsPage]No next page exists",
"error.nextCommitsPage.vfsNotInit": "[nextCommitsPage]Please initialize VirtualFS first",
"error.opfs.connectFailed": "[opfsRoots]Connection failed: {err}",
"error.opfs.failed": "[opfsRoots]Failed to retrieve data: {err}",
"error.opfs.missing": "[opfsRoots]OpfsStorage is not included in the bundle.",
"error.pushLocal.failed": "[pushLocalBtn]Push local failed: {err}",
"error.pushLocal.noAdapter": "[pushLocalBtn]Please connect the adapter first.",
"error.pushLocal.vfsNotInit": "[pushLocalBtn]Please initialize VirtualFS first.",
"error.remoteChanges.failed": "[remoteChangesBtn]Remote changes failed: {err}",
"error.remoteChanges.notImplemented": "[remoteChangesBtn]getRemoteDiffs() does not exist on VirtualFS.",
"error.remoteChanges.vfsNotInit": "[remoteChangesBtn]Please initialize VirtualFS first.",
"error.rename.failed": "[renameBtn]renameBtn failed: {err}",
"error.rename.noAdapter": "[renameBtn]Please connect adapter first",
"error.rename.vfsNotInit": "[renameBtn]Please initialize VirtualFS first",
"error.resolveConflict.failed": "[resolveConflictBtn]resolveConflict failed: {err}",
"error.resolveConflict.notImplemented": "[resolveConflictBtn]VirtualFS does not implement resolveConflict()",
"error.revertChange.backendException": "[revertChangeBtn]Exception in backend.deleteBlob: {err}",
"error.revertChange.backendNoDelete": "[revertChangeBtn]The backend does not support deleteBlob.",
"error.revertChange.failed": "[revertChangeBtn]Failed to revert changes: {err}",
"error.revertChange.readFailed": "[revertChangeBtn]Exception while reading file: {err}",
"error.revertChange.vfsReinitFailed": "[revertChangeBtn]Exception during VirtualFS reinitialization: {err}",
"error.showSnapshot.failed": "[showSnapshotBtn]Exception getting snapshot list: {err}",
"error.showSnapshot.unexpected": "[showSnapshotBtn]Exception showing list: {err}",
"error.showSnapshot.vfsNotInit": "[showSnapshotBtn]Please initialize VirtualFS first",
"error.showFileContent.failed": "[showFileContentBtn]Exception while showing content: {err}",
"error.showFileContent.readFailed": "[showFileContentBtn]Read failed: {path} {err}",
"error.showFileContent.vfsNotInit": "[showFileContentBtn]Please initialize VirtualFS first",
"error.showConflictContent.failed": "[showConflictContentBtn]Exception while showing content: {err}",
"error.showConflictContent.notImplemented": "[showConflictContentBtn]VirtualFS does not implement readConflict()",
"error.showConflictContent.readFailed": "[showConflictContentBtn]Read failed: {path} {err}",
"error.showConflictContent.vfsNotInit": "[showConflictContentBtn]Please initialize VirtualFS first",
"error.switchBranch.exception": "[switchBranch]Exception: {err}",
"error.switchBranch.pullFailed": "[switchBranch]Failed to switch branch via pull: {err}",
"error.switchBranch.vfsNotConnected": "[switchBranch]VirtualFS is not connected.",

"error.vfs.cleanup": "[{prefix}]Exception during existing VirtualFS cleanup: {err}",
"error.vfs.connectFailed": "[{prefix}]Connection failed: {err}",
"error.vfs.initException": "[{prefix}]VirtualFS.init() exception: {err}",
"error.vfs.missing": "[{prefix}]{displayName}/VirtualFS not found",
"error.vfs.notConnected": "[connectBtn]VirtualFS is not connected. Cannot register adapter info",
"error.vfs.setAdapter": "[connectBtn]Failed to set adapter info to VirtualFS: {err}",
"error.vfs.uninitialized": "[{prefix}]VirtualFS is not connected",
"form.branch": "Branch:",
"form.connect": "Update connection",
"form.platform": "Platform:",
"form.repo": "Repository URL:",
"form.token": "Token:",
"listBranches.label": "Fetch branches",
"listCommits.label": "Fetch commits",
"log.addLocalFile.added": "[addLocalFileBtn]Added file to local workspace: {path}, {content}",
"log.connect.input": "[connectBtn]Input: repo={repo} token={token}",
"log.connect.start": "[connectBtn]Setting up connection...",
"log.createBranch.ref": "[createBranch]ref: {ref}",
"log.createBranch.sha": "[createBranch]sha: {sha}",
"log.createBranch.start": "[createBranch]Creating new branch...",
"log.createBranch.success": "[createBranch]Created: {name}",
"log.deleteAndPush.deleted": "[deleteAndPushBtn]Deleted locally: {path}",
"log.deleteAndPush.start": "[deleteAndPushBtn]Start deleting existing file...",
"log.deleteIndexedDb.done": "[deleteIndexedDbBtn]IndexedDB {val} を削除しました",
"log.deleteIndexedDb.start": "[deleteIndexedDbBtn]Deleting the selected IndexedDB...",
"log.deleteInMemory.done": "[deleteInMemoryBtn]Deleted InMemory root {val}",
"log.deleteInMemory.start": "[deleteInMemoryBtn]Deleting the selected InMemory root...",
"log.deleteOpfs.done": "[deleteOpfsBtn]Deleted OPFS root {val}",
"log.deleteOpfs.start": "[deleteOpfsBtn]Deleting the selected OPFS root...",
"log.editAndPush.edited": "[editAndPushBtn]Edited locally: {path}",
"log.editAndPush.start": "[editAndPushBtn]Start editing existing file...",
"log.fetchRemote.addedFiles": "[fetchRemoteBtn]Files newly registered by pull: {list}",
"log.fetchRemote.conflictBaseSha": "[fetchRemoteBtn]  baseSha: {sha}",
"log.fetchRemote.conflictEnd": "[fetchRemoteBtn]--- end ---",
"log.fetchRemote.conflictHeader": "[fetchRemoteBtn]--- Conflict details ---",
"log.fetchRemote.conflictPath": "[fetchRemoteBtn]path: {path}",
"log.fetchRemote.conflictRemoteSha": "[fetchRemoteBtn]  remoteSha: {sha}",
"log.fetchRemote.conflictShowException": "[fetchRemoteBtn]  Exception showing conflict: {err}",
"log.fetchRemote.conflictWorkspaceSha": "[fetchRemoteBtn]  workspaceSha: {sha}",
"log.fetchRemote.fetchContentCount": "[fetchRemoteBtn]fetchContent target file count: {count}",
"log.fetchRemote.indexCount": "[fetchRemoteBtn]Index file count: {count}",
"log.fetchRemote.indexTop": "[fetchRemoteBtn]Index top files: {list}",
"log.fetchRemote.localReadError": "[fetchRemoteBtn]  local read error: {err}",
"log.fetchRemote.localSnippet": "[fetchRemoteBtn]  local (workspace) snippet: {snippet}",
"log.fetchRemote.moreFiles": "[fetchRemoteBtn]... and {n} more",
"log.fetchRemote.pullDone": "[fetchRemoteBtn]Pull complete. Conflicts: {count}",
"log.fetchRemote.reconciled": "[fetchRemoteBtn]Files reconciled by local match: {list}",
"log.fetchRemote.remoteCount": "[fetchRemoteBtn]Remote files count: {count}",
"log.fetchRemote.remoteReadError": "[fetchRemoteBtn]  remote read error: {err}",
"log.fetchRemote.remoteSnippet": "[fetchRemoteBtn]  remote snippet: {snippet}",
"log.fetchRemote.remoteTop": "[fetchRemoteBtn]Remote top files: {list}",
"log.fetchRemote.resolvedConflicts": "[fetchRemoteBtn]Resolved conflicts count: {count}",
"log.fetchRemote.start": "[fetchRemoteBtn]Getting remote snapshot...",
"log.github.adapterCreated": "GitHubAdapter created",
"log.github.registered": "Registered GitHub connection info to VirtualFS (branch={branch})",
"log.gitlab.adapterCreated": "GitLabAdapter created",
"log.gitlab.registered": "Registered GitLab connection info to VirtualFS (branch={branch})",
"log.indexeddb.availableRoots": "[indexedDbRoots]availableRoots: {roots}",
"log.inmemory.availableRoots": "[inMemoryRoots]availableRoots: {roots}",
"log.inmemory.availableRootsStart": "[inMemoryRoots]Calling availableRoots()...",
"log.listBranches.count": "[listBranches]Branches fetched: {count}",
"log.listBranches.paging": "[listBranches]nextPage: {next} lastPage: {last}",
"log.listBranches.start": "[listBranches]Fetching branch list...",
"log.listCommits.count": "[listCommits]Commits fetched: {count}",
"log.listCommits.more": "[listCommits]... and {n} more",
"log.listCommits.paging": "[listCommits]nextPage: {next} lastPage: {last}",
"log.listCommits.start": "[listCommits]Fetching commits...",
"log.listFilesRaw.backendCount": "[listFilesRaw]Items fetched (backend): {count}",
"log.listFilesRaw.count": "[listFilesRaw]Items fetched: {count}",
"log.listFilesRaw.start": "[listFilesRaw]listFilesRaw() executed (no args)",
"log.localChanges.list": "[localChangesBtn]Local changes:\n{json}",
"log.nextCommitsPage.count": "[nextCommitsPage]Commits fetched: {count}",
"log.nextCommitsPage.current": "[nextCommitsPage]currentPage: {current} lastPage: {last}",
"log.nextCommitsPage.start": "[nextCommitsPage]Fetching next commits page...",
"log.opfs.availableRoots": "[opfsRoots]availableRoots: {roots}",
"log.pushLocal.noChanges": "[pushLocalBtn]No changes to push.",
"log.pushLocal.start": "[pushLocalBtn]Pushing local change set to remote...",
"log.pushLocal.success": "[pushLocalBtn]Push succeeded: {json}",
"log.remoteChanges.count": "[remoteChangesBtn]Number of remote diff files: {count}",
"log.remoteChanges.start": "[remoteChangesBtn]Fetching diffs between remote and local...",
"log.rename.renamed": "[renameBtn]Renamed locally: {from} -> {to}",
"log.rename.start": "[renameBtn]Start renaming existing file...",
"log.resolveConflict.notFoundOrFailed": "[resolveConflictBtn]Conflict file not found or delete failed: {path}",
"log.resolveConflict.succeeded": "[resolveConflictBtn]Conflict resolved: {path}",
"log.revertChange.deleting": "[revertChangeBtn]Removing workspace change: {path}",
"log.revertChange.done": "[revertChangeBtn]Operation completed: {path} -> {snippet}",
"log.showSnapshot.count": "[showSnapshotBtn]Files count: {count}",
"log.showSnapshot.fileEntry": "[showSnapshotBtn]- {path}",
"log.showSnapshot.noFiles": "[showSnapshotBtn]No files in snapshot",
"log.showSnapshot.start": "[showSnapshotBtn]Getting snapshot paths...",
"log.showFileContent.start": "[showFileContentBtn]Showing file content: {path}",
"log.showFileContent.content": "[showFileContentBtn]{path} =>\n{content}",
"log.showConflictContent.start": "[showConflictContentBtn]Showing conflict content: {path}",
"log.showConflictContent.content": "[showConflictContentBtn]{path} =>\n{content}",
"log.switchBranch.pulled": "[switchBranch]Branch switch via pull completed: {branch}",
"log.switchBranch.start": "[switchBranch]Switching branch to {branch}...",
"log.vfs.closed": "[{prefix}]Closed VirtualFS",
"log.vfs.closing": "[{prefix}]Closing current VirtualFS...",
"log.vfs.created": "[{prefix}]Created VirtualFS and connected {displayName} ({suffixLabel}={val})",
"log.vfs.createdShort": "VirtualFS created",
"log.vfs.initDone": "VirtualFS.init() done ({displayName})",
"log.vfs.initRunning": "[{prefix}]VirtualFS.init() running ({displayName})",
"nextCommitsPage.label": "Next commits page",
"prompt.addLocalFile.content": "Please enter the file content.",
"prompt.addLocalFile.name": "Please enter the name of the file to create (e.g. examples/new.txt).",
"prompt.createBranch.fromRef": "Please enter the base SHA or ref (leave empty for default).",
"prompt.createBranch.name": "Please enter the name of the branch to create.",
"prompt.deleteAndPush.path": "Please enter the path of the file to delete (e.g. examples/file.txt).",
"prompt.editAndPush.newContent": "Please enter the new file content.",
"prompt.editAndPush.path": "Please enter the path of the file to edit (e.g. examples/file.txt).",
"prompt.indexedDbName": "Please enter the IndexedDB database name (leave empty for default).",
"prompt.inmemoryRootName": "Please enter the InMemory root name (leave empty for default).",
"prompt.opfsRootName": "Please enter the OPFS root name (leave empty for default).",
"prompt.rename.from": "Please enter the source file path (e.g. examples/old.txt).",
"prompt.rename.to": "Please enter the new file name (e.g. examples/new.txt).",
"prompt.resolveConflict": "Please enter the file name to resolve the conflict (e.g. examples/new.txt).",
"prompt.revertChange": "Please enter the file path to revert (e.g. examples/new.txt).",
"prompt.showFileContent.path": "Please enter the file path to show (e.g. examples/new.txt).",
"prompt.showConflictContent.path": "Please enter the file path to show conflict content (e.g. examples/new.txt).",
"prompt.showSnapshot.dir": "Please enter the directory to list (empty for root).",
"prompt.switchBranch": "Please enter the target branch name.",
"results.clear": "Clear",
"results.clearTrace": "Clear",
"results.title": "Results",
"storage.add": "Add",
"storage.close": "Close",
"storage.delete": "Delete",
"storage.indexeddb": "IndexedDB",
"storage.inmemory": "InMemory",
"storage.opfs": "OPFS",
"storage.refresh": "Refresh availableRoots",
"storage.title": "Storage: availableRoots",
"switchBranch.label": "Switch branch",
"actions.listCommits": "Fetch commits",
"actions.nextCommitsPage": "Next commits page",
"actions.listBranches": "Fetch branches",
"actions.createBranch": "Create branch",
"actions.switchBranch": "Switch branch",
"trace.awaitVfsInit": "await currentVfs.init()",
"trace.backendInstanceCreate": "//[{namespace}]Creating backend instance: {displayName}",
"trace.constBackend": "const backend = new {displayName}(\"{namespace}\",{val})",
"trace.empty": " ",
"trace.indexedDbRootsCall": "[indexedDbRoots]Calling availableRoots()...",
"trace.indexedDbRootsJson": "[indexedDbRoots]availableRoots: {json}",
"trace.inMemoryRootsCall": "[inMemoryRoots]Calling availableRoots()...",
"trace.inMemoryRootsJson": "[inMemoryRoots]availableRoots: {json}",
"trace.loggerFmtError": "[logger]format error: {err}",
"trace.loggerFmtStringConvFailed": "[logger]string conversion failed: {err}",
"trace.newVfs": "const currentVfs = new VirtualFS({ backend, logger })",
"trace.opfsRootsCall": "[opfsRoots]Calling availableRoots()...",
"trace.opfsRootsJson": "[opfsRoots]availableRoots: {json}",
"trace.raw": "{msg}",
"trace.vfsDebug": "[vfs]DEBUG: {msg}",
"trace.vfsError": "[vfs]ERROR: {msg}",
"trace.vfsInfo": "[vfs]INFO: {msg}",
"trace.vfsWarn": "[vfs]WARN: {msg}",
"ui.description": "Enter repository URL and Personal Access Token to try the library.",
"ui.empty": "(none)",
"ui.title": "browser-git-ops - Sample UI",
"trace.setListContents.domError": "[setListContents]DOM error: {err}",
"trace.clearOutput.error": "[clearOutputBtn]clear output error: {err}",
"trace.getCurrentAdapter.error": "[getCurrentAdapter] error: {err}",
"trace.vfs.closeCall": "await currentVfs.close()",
"trace.vfs.disposeCall": "await currentVfs.dispose()",
"trace.connectBtn.createDefaultInMemoryFailed": "[connectBtn] failed to create default InMemory VirtualFS: {err}",
"trace.adapter.setGitHubAdapter": "await currentVfs.setAdapter('github', url, branch, token) => opts: {opts}",
"trace.adapter.setGitLabAdapter": "await currentVfs.setAdapter('gitlab', url, branch, token) => opts: {opts}",
"trace.connect.exceptionJson": "connect exception: {json}",
"trace.switchBranch.pullCall": "const res = await currentVfs.pull({ ref: '{target}' })",
"trace.switchBranch.pullResult": "pull => {res}",
"trace.switchBranch.setBranchInputFailed": "[switchBranch] set branchInput failed: {err}",
"trace.opfsRoots.availableRootsError": "[opfsRoots]availableRoots await error: {err}",
"trace.indexedDbRoots.availableRootsError": "[indexedDbRoots]availableRoots await error: {err}",
"trace.populateAdapterMetadata.unexpectedError": "[populateAdapterMetadata] unexpected error: {err}",
"trace.connectVfs.pendingAdapterError": "[connectVfs] Failed to set pending adapter: {err}",
"trace.connectVfs.pendingAdapterOuterError": "[connectVfs] Outer error in pending adapter handling: {err}",
"trace.fetchRemote.comment": "// リポジトリアクセス",
"trace.fetchRemote.pullCall": "const res = await currentVfs.pull({ ref: '{branch}' })",
"trace.fetchRemote.pullResult": "res => {res}",
"trace.resolveConflict.comment": "//",
"trace.resolveConflict.call": "const ok = await currentVfs.resolveConflict({path})",
"trace.resolveConflict.result": "ok => {ok}",
"trace.revertChange.comment": "//",
"trace.revertChange.deleteBlobCall": "await backend.deleteBlob({path}, 'workspace')",
"trace.revertChange.vfsInitCall": "await currentVfs.init()",
"trace.addLocalFile.comment": "// ファイルの書き込み",
"trace.addLocalFile.writeCall": "await currentVfs.writeFile('{path}', '{content}')",
"trace.localChanges.comment": "// ローカルのチェンジセット取得",
"trace.localChanges.getChangeSetCall": "const changes = await currentVfs.getChangeSet()",
"trace.localChanges.result": "changes => {res}",
"trace.pushLocal.comment": "// ローカルのチェンジセットをリモートに push",
"trace.pushLocal.getChangeSetCall": "const changes = await currentVfs.getChangeSet()",
"trace.pushLocal.changesResult": "changes => {res}",
"trace.pushLocal.getIndexCall": "const idx = await currentVfs.getIndex()",
"trace.pushLocal.indexResult": "idx => {res}",
"trace.pushLocal.pushCall": "const res = await currentVfs.push({input})",
"trace.pushLocal.pushResult": "res => {res}",
"trace.editAndPush.comment": "// 既存ファイルの読み取り",
"trace.editAndPush.readCall": "const existing = await currentVfs.readFile('{path}')",
"trace.editAndPush.existingResult": "existing => {res}",
"trace.editAndPush.writeCall": "await currentVfs.writeFile('{path}', '{content}')",
"trace.deleteAndPush.comment": "// 既存ファイルの削除",
"trace.deleteAndPush.unlinkCall": "await currentVfs.unlink('{path}')",
"trace.rename.comment": "// 既存ファイルの名前変更",
"trace.rename.renameCall": "await currentVfs.renameFile('{from}', '{to}')",
"trace.showSnapshot.comment": "// スナップショット内のパス一覧を取得",
"trace.showSnapshot.readdirCall": "const paths = await currentVfs.readdir('{dir}')",
"trace.showSnapshot.pathsResult": "paths => {res}",
"trace.showFileContent.readCall": "const content = await currentVfs.readFile('{path}')",
"trace.showConflictContent.readCall": "const content = await currentVfs.readConflict('{path}')",
"trace.remoteChanges.comment": "//",
"trace.remoteChanges.call": "const res = await currentVfs.getRemoteDiffs()",
"trace.remoteChanges.result": "res => {res}",
"trace.listCommits.comment": "// VirtualFS.listCommits を呼び出します",
"trace.listCommits.call": "const page = await currentVfs.listCommits({query})",
"trace.listCommits.result": "listCommits => {res}",
"trace.nextCommitsPage.comment": "// VirtualFS.listCommits (next page) を呼び出します",
"trace.nextCommitsPage.result": "listCommits(next) => {res}",
"trace.listBranches.comment": "// VirtualFS.listBranches を呼び出します",
"trace.listBranches.call": "const page = await currentVfs.listBranches({query})",
"trace.listBranches.result": "listBranches => {res}",
"trace.listBranches.itemError": "[listBranches] per-item error: {err}",
"trace.createBranch.comment": "// VirtualFS.createBranch を呼び出します",
"trace.createBranch.call": "const res = await currentVfs.createBranch({input})",
"trace.createBranch.result": "createBranch => {res}",
"trace.listFilesRaw.comment": "// VirtualFS の listFilesRaw() を実行",
"trace.listFilesRaw.call": "const files = await currentVfs.listFilesRaw()",
"trace.listFilesRaw.result": "files => {res}",
"trace.listFilesRaw.backendCall": "const files = await backend.listFilesRaw()",
"trace.listFilesRaw.backendResult": "files => {res}"
}